import { useMemo } from "react";
import { useGomakeTheme } from "@/hooks/use-gomake-thme";
import { FONT_FAMILY } from "@/utils/font-family";
import { useIsMobile } from "@/hooks/use-responsive";

const useStyle = ({ isUnderLine }: { isUnderLine?: boolean }) => {
  const isMobile = useIsMobile();
  const { grayColor } = useGomakeTheme();
  const classes = useMemo(() => {
    return {
      inputMainContainer: {
        display: "flex",
        flexDirection: "row" as "row",
        justifyContent: "flex-start",
        alignItems: "center",
        gap: 6,
        height: 28,
        ...(isMobile && {
          gap: 8,
          width: "100%",
          minWidth: 0,
          minHeight: 28,
          height: "auto",
        }),
      },
      labelStyle: {
        ...FONT_FAMILY.Lexend(400, 14),
        color: grayColor(500),
        ...(isMobile && {
          flexShrink: 0,
          width: "38%",
          maxWidth: "130px",
          minWidth: "90px",
        }),
      },
      valueWrapper: {
        display: "flex",
        flex: 1,
        minWidth: 0,
        alignItems: "center",
      },
      inputTextStyle: {
        ...FONT_FAMILY.Lexend(400, 16),
        color: grayColor(900),
        lineHeight: "20px",
        border: "none",
        cursor: "pointer",
        borderRadius: 4,
        padding: "4px 6px",
        width: "fit-content",
        minHeight: "32px",
        textDecoration: isUnderLine ? "underline" : "none",
        ...(isMobile && {
          flex: 1,
          minWidth: 0,
          width: "auto",
          maxWidth: "100%",
          wordBreak: "break-word" as "break-word",
          boxSizing: "border-box" as "border-box",
        }),
      },
    };
  }, [isUnderLine, isMobile, grayColor]);
  return {
    classes,
    isMobile,
  };
};
export { useStyle };
